'use strict';

const fuzzy = require('../fuzzy.js')


module.exports = (function() {

   return {
      isMealPresent: isMealPresent,
      evaluateFractionning: evaluateFractionning,
      getMealPercentage: getMealPercentage,
      computeNutrientValue: computeNutrientValue,
      getNutrientAbsoluteRange: getNutrientAbsoluteRange,
      getNutrientLimSup: getNutrientLimSup,
      getMealScore: getMealScore,
   }

   function isMealPresent(fractionning, index) {
      return fractionning && fractionning.mealPresenceArray.indexOf(index) !== -1
   }

   // categorize the way meals are split
   function evaluateFractionning(fractionning) {
      let nbMeals = fractionning.mealPresenceArray.length
      let evalFract
      if (nbMeals === 2 && (isMealPresent(fractionning, 0) || isMealPresent(fractionning, 2)) && isMealPresent(fractionning, 4)) {
         evalFract = 1
      } else if (nbMeals === 3 && (isMealPresent(fractionning, 0) || isMealPresent(fractionning, 1)) && isMealPresent(fractionning, 2) && isMealPresent(fractionning, 4)) {
         evalFract = 2
      } else if (nbMeals === 3 && isMealPresent(fractionning, 2) && isMealPresent(fractionning, 3) && isMealPresent(fractionning, 4)) {
         evalFract = 10
      } else if (nbMeals === 4 && isMealPresent(fractionning, 0) && isMealPresent(fractionning, 2) && isMealPresent(fractionning, 4)) {
         evalFract = 3
      } else if (nbMeals === 4 && isMealPresent(fractionning, 0) && isMealPresent(fractionning, 1) && isMealPresent(fractionning, 3) && isMealPresent(fractionning, 4)) {
         evalFract = 4
      } else if (nbMeals === 4 && isMealPresent(fractionning, 0) && isMealPresent(fractionning, 2) && isMealPresent(fractionning, 3) && isMealPresent(fractionning, 5)) {
         evalFract = 5
      } else if ((isMealPresent(fractionning, 0) || isMealPresent(fractionning, 1)) && (nbMeals === 4) && isMealPresent(fractionning, 2) && isMealPresent(fractionning, 3) && isMealPresent(fractionning, 4)) {
         evalFract = 8
      } else if (nbMeals === 5 && isMealPresent(fractionning, 0) && isMealPresent(fractionning, 2) && isMealPresent(fractionning, 4)) {
         evalFract = 6
      } else if (nbMeals === 6) {
         evalFract = 7
      } else {
         evalFract = 0
      }
      return evalFract
   }

   function getMealPercentage(fractionningCategory, lowCalories, mealIndex) {
      if (fractionningCategory === 0) {
         // hors categorie
         return 40
      } else if (fractionningCategory === 1) {
         if (mealIndex === 0) {
            return 50
         } else if (mealIndex === 2) {
            return 50
         } else if (mealIndex === 4) {
            return 50
         }
      } else if (fractionningCategory === 2) {
         if (mealIndex === 0) {
            return 20
         } else if (mealIndex === 1) {
            return 20
         } else if (mealIndex === 2) {
            return 40
         } else if (mealIndex === 4) {
            return 40
         }
      } else if (fractionningCategory === 3) {
         if (mealIndex === 0) {
            return 20
         } else if (mealIndex === 1) {
            return lowCalories ? 5 : 10
         } else if (mealIndex === 2) {
            return lowCalories ? 37 : 35
         } else if (mealIndex === 3) {
            return lowCalories ? 5 : 10
         } else if (mealIndex === 4) {
            return lowCalories ? 38 : 35
         } else if (mealIndex === 5) {
            return lowCalories ? 5 : 10
         }
      } else if (fractionningCategory === 4) {
         if (mealIndex === 0) {
            return 20
         } else if (mealIndex === 1) {
            return 20
         } else if (mealIndex === 3) {
            return 20
         } else if (mealIndex === 4) {
            return 40
         }
      } else if (fractionningCategory === 5) {
         if (mealIndex === 0) {
            return 20
         } else if (mealIndex === 2) {
            return 40
         } else if (mealIndex === 3) {
            return 20
         } else if (mealIndex === 5) {
            return 20
         }
      } else if (fractionningCategory === 6) {
         if (mealIndex === 0) {
            return 20
         } else if (mealIndex === 1) {
            return lowCalories ? 5 : 10
         } else if (mealIndex === 2) {
            return lowCalories ? 35 : 30
         } else if (mealIndex === 3) {
            return lowCalories ? 5 : 10
         } else if (mealIndex === 4) {
            return lowCalories ? 35 : 30
         } else if (mealIndex === 5) {
            return lowCalories ? 5 : 10
         }
      } else if (fractionningCategory === 7) {
         if (mealIndex === 0) {
            return 20
         } else if (mealIndex === 1) {
            return lowCalories ? 5 : 8
         } else if (mealIndex === 2) {
            return lowCalories ? 32 : 30
         } else if (mealIndex === 3) {
            return lowCalories ? 5 : 7
         } else if (mealIndex === 4) {
            return lowCalories ? 33 : 30
         } else if (mealIndex === 5) {
            return 5
         }
      } else if (fractionningCategory === 8) {
         if (mealIndex === 0) {
            return 20
         } else if (mealIndex === 1) {
            return 20
         } else if (mealIndex === 2) {
            return 35
         } else if (mealIndex === 3) {
            return 15
         } else if (mealIndex === 4) {
            return 30
         }
      } else if (fractionningCategory === 10) {
         if (mealIndex === 2) {
            return 40
         } else if (mealIndex === 3) {
            return 20
         } else if (mealIndex === 4) {
            return 40
         }
      } else {
         return 0.
      }
   }

   function getNutrientLimSup(nutrient, mealEnergy) {
      if (nutrient.nutr_no === "208") {
         // special case of energy: limsup = 200%
         return mealEnergy * 2.
      } else if (nutrient.nutr_no === "301") {
         // special case of calcium
         return 1000.
      } else if (nutrient.nutr_no === "291") {
         // special case of fibers
         return 25.
      } else {
         // all others: range relative to mealEnergy
         return mealEnergy / nutrient.energy_ratio
      }
   }

   function getNutrientAbsoluteRange(user, nutrient, mealEnergy) {
      if (nutrient.nutr_no === "208") {
         // special case of energy
         let percentRange = { d1: 90., d2: 110., dt1: 15., dt2: 15., h: 0. }
         return fuzzy.multiplyByScalar(percentRange, mealEnergy * 0.01)
      } else if (nutrient.nutr_no === "301") {
         // special case of calcium
         return 1000.
      } else if (nutrient.nutr_no === "291") {
         // special case of fibers
         return 25.
      } else if (nutrient.nutr_no === "205") {
         // special case of carbohydrates
         let percentRange
         if (false && getHypertriglyceridemia(user)) {
            percentRange = { d1: 40., d2: 55., dt1: 5., dt2: 5., h: 0. }
         } else {
            percentRange = { d1: 45., d2: 60., dt1: 5., dt2: 5., h: 0. }
         }
         return fuzzy.multiplyByScalar(percentRange, mealEnergy * 0.01 / nutrient.energy_ratio)
      } else {
         // all others: range is relative to mealEnergy / nutrient.energy_ratio
         let percentRange
         if (nutrient.nutr_no === "203") {
            // proteins
            percentRange = { d1: 10., d2: 18., dt1: 8., dt2: 8., h: 0. }
         } else if (nutrient.nutr_no === "204") {
            // fat
            percentRange = { d1: 30., d2: 35., dt1: 8., dt2: 8., h: 0. }
         }
         return fuzzy.multiplyByScalar(percentRange, mealEnergy * 0.01 / nutrient.energy_ratio)
      }
   }

   function computeNutrientValue(nutr_no, mealElements, foods, foodPortions, nutdatas, food2nutrient2nutdata) {
      // map
      let mealElementNutrientArray = mealElements.map(mealElement => {
         let food, fuzzyWeight
         if (mealElement.food) {
            food = foods[mealElement.food]
            if (!food) { console.log('missing', mealElement); return { d1: 0, d2: 0, dt1: 0, dt2: 0, h: 0 } }
            fuzzyWeight = fuzzy.parse(mealElement.weight)
         } else {
            let foodPortion = foodPortions[mealElement.food_portion]
            if (!foodPortion) { console.log('missing', mealElement); return { d1: 0, d2: 0, dt1: 0, dt2: 0, h: 0 } }
            food = foods[foodPortion.food]
            if (!food) { console.log('missing', mealElement); return { d1: 0, d2: 0, dt1: 0, dt2: 0, h: 0 } }
            let portionWeight = fuzzy.parse(foodPortion.portion_weight)
            fuzzyWeight = fuzzy.multiplyByScalar(portionWeight, parseFloat(foodPortion.nbportion))
         }
         if (!food2nutrient2nutdata[food.id]) { console.log('missing', mealElement); return { d1: 0, d2: 0, dt1: 0, dt2: 0, h: 0 } }
         let foodNutdataId = food2nutrient2nutdata[food.id][nutr_no]
         let foodNutData = nutdatas[foodNutdataId]
         if (!foodNutData) { console.log('missing', mealElement); return { d1: 0, d2: 0, dt1: 0, dt2: 0, h: 0 } }
         let fuzzyNutData = fuzzy.parse(foodNutData.val)
         let fuzzyValue = fuzzy.multiply(fuzzyWeight, fuzzyNutData)
         return fuzzy.multiplyByScalar(fuzzyValue, 0.01)
      })
      // reduce
      let zero = { d1: 0, d2: 0, dt1: 0, dt2: 0, h: 0 }
      return mealElementNutrientArray.reduce(function(accu, mealElementNutrient) {
         return fuzzy.add(accu, mealElementNutrient)
      }, zero)
   }

   function getNutrientWeight(user, nutr_no) {
      if (nutr_no === "208") {
         // energy
         return 10.
      } else if (nutr_no === "205") {
         // carbohydrates
         return 4.
      } else if (nutr_no === "209") {
         // complex carbs
         return (false && getDiabetic(user)) ? 10. : 3.
      } else if (nutr_no === "210") {
         // saccharose
         if (false && getHypertriglyceridemia(user)) {
            return 20.
         } else {
            return (false && getDiabetic(user)) ? 10. : 3.
         }
      } else if (nutr_no === "203") {
         // proteins
         return 6.
      } else if (nutr_no === "204") {
         // fat
         return 4.
      } else if (nutr_no === "606") {
         // saturated fat
         return (false && getHypercholesterolemia(user)) ? 10. : 3.
      } else if (nutr_no === "648") {
         // lipides polyinsaturés
         return 1.
      } else if (nutr_no === "601") {
         // cholesterol
         return (false && getHypercholesterolemia(user)) ? 20. : 2.
      } else if (nutr_no === "301") {
         // calcium
         return 5.
      } else if (nutr_no === "291") {
         // fibres
         return 5.
      } else if (nutr_no === "221") {
         // alcool
         return (false && getHypertriglyceridemia(user)) ? 20. : 1.
      } else if (nutr_no === "307") {
         // sodium
         if (false && getSaltDiet(user) < 8) {
            return 25.
         } else {
            // no salt-free diet -> < 8g/j
            return 1.
         }
      }
   }

   function getMealScore(user, nutrients, mealElements, mealEnergy, foods, foodPortions, nutdatas, food2nutrient2nutdata) {
      let totalw = 0.
      let total = 0.
      nutrients.forEach(nutrient => {
         let s = getMealNutrientScore(user, nutrient, mealElements, mealEnergy, foods, foodPortions, nutdatas, food2nutrient2nutdata)
         let weight = getNutrientWeight(user, nutrient.nutr_no)
         totalw += weight
         total += weight * s
      })
      return total / totalw
   }

   function getMealNutrientScore(user, nutrient, mealElements, mealEnergy, foods, foodPortions, nutdatas, food2nutrient2nutdata) {
      let nutrientValue = computeNutrientValue(nutrient.nutr_no, mealElements, foods, foodPortions, nutdatas, food2nutrient2nutdata)
      let nutrientRange = getNutrientAbsoluteRange(user, nutrient, mealEnergy)
      let inclusionDegree = fuzzy.necessity(nutrientRange, nutrientValue)
      let score = 0.
      if (inclusionDegree >= 0.99) {
         score = 1.
      } else {
         let overlapDegree = fuzzy.possibility(nutrientRange, nutrientValue)
         score = inclusionDegree * 0.8 + overlapDegree * 0.2
      }
      return score
   }

})()



// WEBPACK FOOTER //
// ./src/utilities/nutrition/nutrition.js